import styles from './style.m.less';

export default function NotificationsDotButton({ children }: { children?: React.ReactNode }) {
    'use memo';

    return <span className={styles.dot}>{children}</span>;
}
